export default __webpack_public_path__ + "img/rewards-artwork-09204ec3cf72d69cddbb1c933b76b803.png";